/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet"

function SEO({
  lang = `en`,
  meta = [],
  description = ``,
  title,
  image,
  url,
  keywords,
  extrameta = [],
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            keywords
            siteUrl
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  const ogImage = image
  let baseUrl = site.siteMetadata?.siteUrl
  baseUrl += baseUrl.endsWith("/") ? "" : "/"
  let pageUrl = baseUrl
  if (url !== undefined || url !== null) {
    pageUrl = baseUrl + url
  }

  var allMeta = [
    {
      name: `description`,
      content: metaDescription,
    },
    {
      name: `keywords`,
      content: keywords,
    },
    {
      property: `og:title`,
      content: title + " | " + defaultTitle,
    },
    {
      property: `og:description`,
      content: metaDescription,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      property: `og:url`,
      content: pageUrl,
    },
    {
      property: `og:image`,
      content: baseUrl + ogImage, // should be in static root // quotient-social.png
    },
    {
      name: `twitter:card`,
      content: `summary_large_image`,
    },
    {
      name: `twitter:creator`,
      content: site.siteMetadata?.author || ``,
    },
    {
      name: `twitter:title`,
      content: title,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
    {
      property: `twitter:image`,
      content: baseUrl + ogImage, // should be in static root // quotient-social.png
    },
    {
      name: `google-play-app`,
      content: "com.qps.quotient",
    },
  ]
    .concat(meta)
    .concat(extrameta)

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={title ? `%s | ${defaultTitle}` : null}
      meta={allMeta}
    />
  )
}

// SEO.defaultProps = {
//   lang: `en`,
//   meta: [],
//   description: ``,
// }

// SEO.propTypes = {
//   description: PropTypes.string,
//   lang: PropTypes.string,
//   meta: PropTypes.arrayOf(PropTypes.object),
//   title: PropTypes.string.isRequired,
// }

export default SEO
